import { formatMoney } from '@erp/shared';
import { Plus } from 'lucide-react';
import { Link } from 'react-router';

import { useContactDeals } from '../../lib/deals-api.ts';
import { useCan } from '../../lib/session.ts';
import { DealStatusBadge, StaleBadge } from '../deals/badges.tsx';
import { buttonVariants } from '../ui/button.tsx';
import { Card } from '../ui/card.tsx';

/** HU-CON-06: the contact's deals (as client or participant). */
export function ContactDealsCard({ contactId }: { contactId: string }) {
  const deals = useContactDeals(contactId);
  const canEdit = useCan('records.edit');
  const items = deals.data?.items ?? [];
  const hidden = deals.data?.hiddenCount ?? 0;
  return (
    <Card className="space-y-3">
      <div className="flex items-center justify-between gap-2">
        <h2 className="font-semibold">Negocios</h2>
        {canEdit && (
          <Link
            to={`/negocios/nuevo?contacto=${contactId}`}
            className={buttonVariants({ size: 'sm', variant: 'secondary' })}
          >
            <Plus /> Nuevo
          </Link>
        )}
      </div>
      {items.length === 0 && hidden === 0 ? (
        <p className="text-sm text-muted-foreground">Sin negocios.</p>
      ) : (
        <ul className="divide-y divide-border text-sm">
          {items.map((d) => (
            <li key={d.id} className="space-y-1 py-2">
              <div className="flex flex-wrap items-baseline justify-between gap-2">
                <Link to={`/negocios/${d.id}`} className="font-medium text-primary hover:underline">
                  {d.title}
                </Link>
                {d.estimatedAmount !== null && (
                  <span className="tabular-nums">{formatMoney(d.estimatedAmount)}</span>
                )}
              </div>
              <div className="flex flex-wrap items-center gap-1.5 text-xs text-muted-foreground">
                <DealStatusBadge status={d.status} />
                {d.stale && <StaleBadge />}
                <span>
                  {d.pipeline.name} · {d.stage.name} · {d.assignedTo.name}
                </span>
              </div>
            </li>
          ))}
        </ul>
      )}
      {hidden > 0 && (
        <p className="text-xs text-muted-foreground">
          {hidden === 1
            ? 'Otro negocio suyo está a cargo de alguien fuera de tu cartera.'
            : `Otros ${String(hidden)} negocios suyos están a cargo de personas fuera de tu cartera.`}
        </p>
      )}
    </Card>
  );
}
